module.exports = __webpack_public_path__ + "static/cileunca-2c404bea4bb0744402e3fdea4960f3ee.jpeg";